module.exports = __webpack_public_path__ + "static/7-488075d717cdb7ece5354cd999ab9456.jpeg";